module.exports = __webpack_public_path__ + "img/money-pound-circle-line.fa98d19a.svg";